// extracted by mini-css-extract-plugin
export default {"layout-relative":"layout_layout-relative__WAOP4","layout-menu-absolute":"layout_layout-menu-absolute__XNtHH"};